import React, { useEffect, useState, useRef } from "react";
import { getAllDeduction, addDeduction, updateDeduction, deleteDeduction } from "../../api/deductionApi";
import "../../css/mastertable.css";
import { hasRight } from "../../utils/userRights";

export default function Deduction() {
  const [deductions, setDeductions] = useState([]);
  const [formData, setFormData] = useState({
    deductionName: "",
    description: "",
    percentage: 0,
    amount: 0,
  });
  const [editId, setEditId] = useState(null);

  const formRef = useRef(null); // reference for form

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const deductionData = await getAllDeduction();
      setDeductions(deductionData.data || deductionData);
    } catch (error) {
      console.error("Error fetching deductions", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.deductionName.trim()) {
      alert("Deduction Name is required.");
      return;
    }

    try {
      const payload = {
        DeductionID: editId || 0,
        DeductionName: formData.deductionName,
        Description: formData.description,
        Percentage: parseFloat(formData.percentage), // ensures decimal is saved
        Amount: parseFloat(formData.amount),
      };


      if (editId) {
        await updateDeduction(editId, payload);
        alert("Deduction updated successfully 🎉");
      } else {
        await addDeduction(payload);
        alert("Deduction added successfully 🎉");
      }

      setFormData({ deductionName: "", description: "", percentage: 0, amount: 0 });
      setEditId(null);
      fetchData();
    } catch (error) {
      console.error("Error saving deduction", error);
      alert("Something went wrong while saving deduction");
    }
  };

  const handleEdit = (item) => {
    setFormData({
      deductionName: item.deductionName || "",
      description: item.description || "",
      percentage: item.percentage || 0,
      amount: item.amount || 0,
    });
    setEditId(item.deductionID);

    // scroll form into view when editing
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      formRef.current.querySelector("input[name='deductionName']")?.focus();
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this deduction?")) {
      try {
        await deleteDeduction(id);
        alert("Deduction deleted successfully 🗑️");
        fetchData();
      } catch (error) {
        console.error("Error deleting deduction", error);
        alert("Failed to delete deduction");
      }
    }
  };

  const handleClear = () => {
    setFormData({ deductionName: "", description: "", percentage: 0, amount: 0 });
    setEditId(null);
  };

return (
  <div className="container mt-4 compact-table-container">
    
    {/* Heading */}
    <h4 className="compact-heading">Deduction Details</h4>

    {/* Add / Edit Form */}
    <form ref={formRef} className="row g-2 mt-0 compact-form" onSubmit={handleSubmit}>
      <div className="col-md-3">
        <label className="form-label">
          Deduction Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="deductionName"
          className="form-control"
          value={formData.deductionName}
          onChange={(e) => setFormData({ ...formData, deductionName: e.target.value })}
          required
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Description</label>
        <input
          type="text"
          name="description"
          className="form-control"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />
      </div>

      <div className="col-md-2">
        <label className="form-label">
          Percentage <span className="text-danger">*</span>
        </label>
        <input
          type="number"
          name="percentage"
          className="form-control"
          value={formData.percentage}
          onChange={(e) => setFormData({ ...formData, percentage: e.target.value })}
          step="0.01"
          min="0"
          required
        />
      </div>

      <div className="col-md-2">
        <label className="form-label">Amount</label>
        <input
          type="number"
          name="amount"
          className="form-control"
          value={formData.amount}
          onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
        />
      </div>

      <div className="col-md-2 d-flex align-items-end">
        {/* <button type="submit" className="btn btn-success me-1">
          {editId ? "Update" : "Add"}
        </button> */}
        {(!editId && hasRight("DeductionMaster", "add")) ||
          (editId && hasRight("DeductionMaster", "update")) ? (
            <button type="submit" className="btn btn-success me-1">
              {editId ? "Update" : "Add"}
            </button>
          ) : null} 
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClear}
        >
          Clear
        </button>
      </div>
    </form>

    {/* Table */}
    <div className="compact-table-container mt-2">
      <table className="compact-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Deduction Name</th>
            <th>Percentage</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {deductions.length > 0 ? (
            deductions.map((item, index) => (
              <tr key={item.deductionID || index}>
                <td>{index + 1}</td>
                <td>{item.deductionName}</td>
                <td>{item.percentage}</td>
                <td>{item.amount}</td>
                <td>
                  {/* <button className="edit" onClick={() => handleEdit(item)}>Edit</button>
                  <button className="delete" onClick={() => handleDelete(item.deductionID)}>Delete</button> */}

                  {/* Edit button → only show if user has Update right */}
                  {hasRight("DeductionMaster", "update") && (
                    <button className="edit" onClick={() => handleEdit(item)}>
                      Edit
                    </button>
                  )}
                
                  {/* Delete button → only show if user has Delete right */}
                  {hasRight("DeductionMaster", "delete") && (
                    <button
                      className="delete"
                      onClick={() => handleDelete(item.deductionID)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">No deductions found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);



}
